import { gql } from "@apollo/client";

export const GET_SYSTEMS = gql`
  query getSystems($page: Int, $limit: Int, $filter: SystemConfigsFilterInputType) {
    getSystems(page: $page, limit: $limit, filter: $filter) {
      success
      message
      data {
        id
        label
        key
        category
        system_admin
        integration_type
        integrated_resource_id
        is_critical
        is_review_active
        review_cycle
        last_reviewed_at
        created_at
        account_label
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_USERS = gql`
  query getUsers($page: Int, $limit: Int, $filter: UserSystemAccessFilterInputType) {
    getUsers(page: $page, limit: $limit, filter: $filter) {
      success
      message
      data {
        id
        name
        email
        role
        review_status
        review_notes
        system {
          id
          label
          key
          category
          system_admin
          is_critical
          is_review_active
          review_cycle
          account_label
        }
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_AUDIT_USERS = gql`
  query getAuditUsers(
    $audit_id: ID!
    $page: Int
    $limit: Int
    $filter: UserSystemAccessFilterInputType
  ) {
    getAuditUsers(audit_id: $audit_id, page: $page, limit: $limit, filter: $filter) {
      success
      message
      data {
        id
        name
        email
        role
        review_status
        review_notes
        system {
          id
          label
          key
          category
          system_admin
          is_critical
          is_review_active
          review_cycle
          account_label
        }
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const CREATE_USERS = gql`
  mutation createUsers($input: CreateUsersInputType!) {
    createUsers(input: $input) {
      success
      message
      data {
        id
        username
        emails
        roles
        integrated_account_id
        rego_valid_from
        created_at
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($userId: String!) {
    deleteUser(userId: $userId) {
      success
      message
      data {
        id
      }
    }
  }
`;

export const UPDATE_CRITICAL_SYSTEM_OWNER = gql`
  mutation updateCriticalSystemOwner($id: String!, $owner: String!) {
    updateCriticalSystemOwner(id: $id, owner: $owner) {
      id
      owner
    }
  }
`;

export const CREATE_MANUAL_SYSTEM = gql`
  mutation createManualSystem($input: SystemConfigsCreateInputType!) {
    createManualSystem(input: $input) {
      success
      message
      data {
        id
      }
    }
  }
`;

export const UPDATE_SYSTEM = gql`
  mutation updateSystem($systemId: String!, $input: UpdateSystemInput!) {
    updateSystem(systemId: $systemId, input: $input) {
      success
      message
      data {
        system_id
      }
    }
  }
`;

export const UPDATE_SYSTEM_CONFIGS = gql`
  mutation updateSystemConfigs($input: [SystemConfigsUpdateInputType]!) {
    updateSystemConfigs(input: $input) {
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;

export const GET_ACCESS_ASSESSMENT_ITEMS_BY_ID = gql`
  query GetAccessAssessmentItems($assessment_id: Int!) {
    getAccessAssessmentItemsById(assessment_id: $assessment_id) {
      success
      message
      data {
        id
        assessment_id
        user_access_review_id
        user_name
        user_email
        user_role
        review_status
        review_notes
        comments
        created_at
        updated_at
        last_reviewed_date
        assessment_title
      }
    }
  }
`;

export const GET_ASSESSMENT = gql`
  query GetAssessment($page: Int, $limit: Int, $filter: AccessAssessmentFilterInputType) {
    getAssessment(page: $page, limit: $limit, filter: $filter) {
      success
      message
      data {
        id
        title
        description
        resource_id
        reviewer_email
        created_at
        updated_at
        completed_at
        status_title
        system_name
        system_category
      }
    }
  }
`;

export const GET_AUDIT_ASSESSMENT = gql`
  query GetAuditAssessment(
    $audit_id: ID!
    $page: Int
    $limit: Int
    $filter: AccessAssessmentFilterInputType
  ) {
    getAuditAssessment(
      audit_id: $audit_id
      page: $page
      limit: $limit
      filter: $filter
    ) {
      success
      message
      data {
        id
        title
        description
        resource_id
        reviewer_email
        created_at
        updated_at
        completed_at
        status_title
        system_name
        system_category
      }
    }
  }
`;

export const START_ACCESS_REVIEW_ASSESSMENT = gql`
  mutation StartAccessReviewAssessment($assesement_data: AccessAssessmentCreateInputType!) {
    startAccessReviewAssesement(assesement_data: $assesement_data) {
      success
      message
      data {
        id
        title
        description
        resource_id
        status_id
        reviewer_email
        created_at
        updated_at
        completed_at
        status_title
        assessor_name
        assessor_email
      }
    }
  }
`;

export const UPDATE_ACCESS_REVIEW_ASSESSMENT = gql`
  mutation UpdateAccessReviewAssesement($input: [AccessAssessmentUpdateInputType]!) {
    updateAccessReviewAssesement(input: $input) {
      success
      message
      data { id }
    }
  }
`;

export const UPDATE_USER_SYSTEM_ACCESS = gql`
  mutation UpdateUserSystemAccess($input: UserSystemAccessUpdateInputType!) {
    updateUserInfo(input: $input) {
      success
      message
      data {
        id
        name
        email
        role
        review_status
        review_notes
        system {
          id
          label
          key
          category
          created_at
          updated_at
          system_admin
          is_critical
          is_review_active
          review_cycle
          last_reviewed_at
        }
      }
    }
  }
`;

